/* global axios */
import ApiClient from './ApiClient';

class InternalChatRoomsApi extends ApiClient {
  constructor() {
    super('internal_chat/rooms', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  markRead(roomId) {
    return axios.post(`${this.url}/${roomId}/mark_read`);
  }

  messages(roomId, params = {}) {
    return axios.get(`${this.url}/${roomId}/messages`, { params });
  }

  sendMessage(roomId, content, attachments = [], additionalData = null) {
    const hasAttachments = Array.isArray(attachments) && attachments.length > 0;

    if (!hasAttachments) {
      return axios.post(`${this.url}/${roomId}/messages`, {
        message: {
          content,
          ...(additionalData && typeof additionalData === 'object'
            ? { additional_data: additionalData }
            : {}),
        },
      });
    }

    const formData = new FormData();
    formData.append('message[content]', content || '');
    if (additionalData && typeof additionalData === 'object') {
      formData.append('message[additional_data]', JSON.stringify(additionalData));
    }
    attachments.forEach(file => {
      formData.append('message[attachments][]', file);
    });
    return axios.post(`${this.url}/${roomId}/messages`, formData);
  }

  updateMessage(roomId, messageId, content) {
    return axios.patch(`${this.url}/${roomId}/messages/${messageId}`, {
      message: { content },
    });
  }

  updateMessageAdditionalData(roomId, messageId, additionalData = {}) {
    return axios.patch(`${this.url}/${roomId}/messages/${messageId}`, {
      message: { additional_data: additionalData },
    });
  }

  deleteMessage(roomId, messageId) {
    return axios.delete(`${this.url}/${roomId}/messages/${messageId}`);
  }

  addMember(roomId, userId) {
    return axios.post(`${this.url}/${roomId}/members`, {
      member: { user_id: userId },
    });
  }

  removeMember(roomId, userId) {
    return axios.delete(`${this.url}/${roomId}/members/${userId}`);
  }
}

export default new InternalChatRoomsApi();
